// extracted by mini-css-extract-plugin
export default {"row":"xW4uK","largePadding":"IKSSa","noPadding":"gMhik","sticky":"G1HCY","content":"nharA"};